export default __webpack_public_path__ + "static/media/marked_as_resolved.ef750c70.svg";